import { GET_NOW_CONDITIONS } from '../actions/nowConditionsActions';

import { LOCATION_CHANGED } from '../actions/locationActions';

const initialState = {
    nowConditionsIsRefreshing: false
};

export function nowConditions(state = initialState, action) {
    switch (action.type) {
        case LOCATION_CHANGED:
        {
            return initialState;
        }

        case GET_NOW_CONDITIONS.pending:
        {
            return {
                ...state,
                nowConditions: undefined,
                lastError: undefined,
                nowConditionsIsRefreshing: true
            };
        }

        case GET_NOW_CONDITIONS.fulfilled:
        {
            return {
                ...state,
                nowConditions: action.payload,
                nowConditionsIsRefreshing: false
            };
        }

        case GET_NOW_CONDITIONS.rejected:
        {
            return {
                ...state,
                lastError: action.payload,
                nowConditionsIsRefreshing: false
            };
        }
        default:
        {
            return state;
        }
    }
}
